"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceBreakpointsType = void 0;
var DeviceBreakpointsType;
(function (DeviceBreakpointsType) {
    DeviceBreakpointsType["MOBILE"] = "MOBILE";
    DeviceBreakpointsType["TABLET"] = "TABLET";
    DeviceBreakpointsType["WEB_DESKTOP"] = "DESKTOP";
})(DeviceBreakpointsType || (exports.DeviceBreakpointsType = DeviceBreakpointsType = {}));
//# sourceMappingURL=types.js.map